//=================================================
//    summary: DCP Image Display Window -- Hook
//
//    remarks: 000 Tim 2021/12/24 Create
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssImageDisplayWindow from './ImageDisplayWindow.module.scss'
import {GlobalLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mintImageType = 1
// #endregion Member Variables

// #region Enumeration
export const ImageTypeEnum = {
    "Composition": 1,
    "Characters": 2
}
// #endregion Enumeration


const COMP_NAME = "ImageDisplayWindow"

function ImageDisplayWindow(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
        }
    }, [props.Arguments])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉
    remarks: 000 Tim 2021/12/14 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowImageDisplayWindow"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler
    // #endregion OnTapHandler

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        if (
            (typeof (props.Arguments) !== 'undefined') &&
            (props.Arguments !== null) &&
            (typeof (props.Arguments.ImageType) !== 'undefined') &&
            (props.Arguments.ImageType !== null) &&
            (parseInt(props.Arguments.ImageType) > 0)
            )
        {
            mintImageType = parseInt(props.Arguments.ImageType)
        }
        else
        {
            mintImageType = ImageTypeEnum.Composition
        }

        setUpdateDataTime(new Date().getTime())
    } // end of PaintedMe
    // #endregion Other Functions

    // #region Get Style
    /*===========================================
    summary: 取得 使用者圖片 Style
    remarks: 000 Tim 2021/12/24 Create
    ===========================================*/
    function GetImageStyle(ImageAnswerUrl)
    {
        let objStyle =  {
            "backgroundImage": "url(\"" + ImageAnswerUrl + "\")"
        }

        return objStyle
    } // end of GetImageStyle
    // #endregion Get Style

    // #region Render
    /*===========================================
    summary: Render UserImage 4 學漢字 的顯示
    remarks: 000 Tim 2021/12/24 Create
    ===========================================*/
    function RenderUserImage4CharactersWrapper(ImageUrl)
    {
        return (
            <div className={cssImageDisplayWindow.divContent}>
                <div className={cssImageDisplayWindow.divUserImageArea}>
                    <img className={cssImageDisplayWindow.imgUserImage} src={ImageUrl} 
                        alt={window.gAppUI.LBL_DownloadImage}/>
                </div>

                <div className={cssImageDisplayWindow.divMessage}>
                    {window.gAppUI.LBL_DownloadImagePageMsg}
                </div>
            </div>
        )
    } // end of RenderUserImage4CharactersWrapper

    /*===========================================
    summary: Render UserImage 4 組合題 的顯示
    remarks: 000 Tim 2021/12/24 Create
    ===========================================*/
    function RenderUserImage4CompositionWrapper(ImageUrl)
    {
        let objStyle = GetImageStyle(ImageUrl)

        return (
            <div className={cssImageDisplayWindow.divContent}>
                <div className={cssImageDisplayWindow.divUserImage} style={objStyle}/>
            </div>
        )
    } // end of RenderUserImage4CompositionWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/24 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            if (mintImageType === ImageTypeEnum.Composition)
            {
                return RenderUserImage4CompositionWrapper(props.Arguments.ImageUrl)
            }
            else
            {
                return RenderUserImage4CharactersWrapper(props.Arguments.ImageUrl)
            }
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/24 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssImageDisplayWindow.divTopTool}>
                <div className={cssImageDisplayWindow.btnCloseMain} onClick={() => CloseOnTapHandler()}>
                    <div className={cssImageDisplayWindow.btnCloseIcon}/>
                </div>
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/24 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssImageDisplayWindow.divMask}>
                <div className={cssImageDisplayWindow.divMain}>
                    {RenderTopToolWrapper()}

                    {RenderContentWrapper(updateDataTime)}
                </div>
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default ImageDisplayWindow